/* Impact owns transitions, swipe, dots and editor block selection. This bridge
   manages intentional pause, reduced motion and existing inventory focus only. */
class MYAKMCarCampaigns extends HTMLElement {
  async connectedCallback() {
    this._abort?.abort();
    this._abort = new AbortController();
    const { signal } = this._abort;
    await customElements.whenDefined('slideshow-carousel');
    if (!this.isConnected || signal.aborted) return;
    this.carousel = this.querySelector('slideshow-carousel');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.manualPaused = false;
    this.editorSelected = false;
    this.inView = true;
    const shouldPause = () => {
      const focusedChild = this.contains(document.activeElement) && document.activeElement !== this.carousel;
      return this.manualPaused || this.editorSelected || this.reduced.matches || !this.inView || document.hidden || this.matches(':hover') || focusedChild;
    };
    const sync = () => {
      const paused = shouldPause();
      this.carousel.setAttribute('aria-live', paused ? 'polite' : 'off');
      if (paused) this.carousel.player?.pause();
      else if (this.dataset.autoplay === 'true') this.carousel.player?.resume();
      this.querySelectorAll('.slideshow__slide').forEach(slide => {
        const inactive = !slide.classList.contains('is-selected');
        slide.inert = inactive;
        slide.setAttribute('aria-hidden', String(inactive));
      });
    };
    this.addEventListener('pointerenter', sync, { signal });
    this.addEventListener('pointerleave', sync, { signal });
    this.addEventListener('focusin', event => { if (event.target === this.carousel) this.manualPaused = true; sync(); }, { signal });
    this.addEventListener('focusout', () => queueMicrotask(sync), { signal });
    this.carousel.addEventListener('carousel:settle', sync, { signal });
    this.reduced.addEventListener('change', sync, { signal });
    document.addEventListener('visibilitychange', sync, { signal });
    const guardPlayer = () => { if (shouldPause()) this.carousel.player?.pause(); };
    this.carousel.player?.addEventListener('player:start', guardPlayer, { signal });
    this.carousel.player?.addEventListener('player:resume', guardPlayer, { signal });
    this.addEventListener('shopify:block:select', () => { this.editorSelected = true; sync(); }, { signal });
    this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; sync(); }, { signal });
    this.carousel.addEventListener('keydown', event => {
      if (event.target !== this.carousel) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        event.key === 'ArrowLeft' ? this.carousel.next() : this.carousel.previous();
      } else if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        this.manualPaused = !this.manualPaused;
        sync();
      }
    }, { signal });
    this.addEventListener('click', event => {
      const action = event.target.closest('[data-car-intent] a');
      if (!action || action.pathname !== location.pathname || !action.hash) return;
      const intent = action.closest('[data-car-intent]').dataset.carIntent;
      const field = intent === 'budget' ? document.querySelector('[data-uc-filters] [name="budget"]') : intent === 'compare' ? document.querySelector('[data-uc-cards] [data-uc-compare]') : null;
      if (field) requestAnimationFrame(() => field.focus({ preventScroll: true }));
    }, { signal });
    this._observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting; sync();
    });
    this._observer.observe(this);
    sync();
  }
  disconnectedCallback() { this._abort?.abort(); this._observer?.disconnect(); }
}
if (!customElements.get('myakm-car-campaigns')) customElements.define('myakm-car-campaigns', MYAKMCarCampaigns);
